<template>
  <div id="app">
    <!-- 移动端菜单 -->
    <div class="mobileMenu" v-if="mobileMenuIsShow">
      <div class="mobile-menu">
        <div class="logo"></div>
        <div class="switch" @click="closeMenuChange">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="menu-content">
        <el-menu
          default-active="2"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          text-color="#334046"
        >
          <el-submenu
            :index="item.index + ''"
            v-for="item in menu"
            :key="item.index"
          >
            <template slot="title">
              <span>{{ item.name }}</span>
            </template>
            <!-- <el-menu-item>111</el-menu-item> -->
            <el-menu-item
              :index="item2.index"
              v-for="item2 in item.children"
              :key="item2.index"
              @click="mobileRouterLink(item2.name)"
            >
              {{ item2.text }}
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
    <!-- /移动端菜单/ -->
    <!-- 主体页面 -->
    <div class="PCcontent" v-else>
      <!-- PC导航 -->
      <div class="nav" v-if="MenuIsShow">
        <div class="logo"></div>
        <div class="menu">
          <ul class="menu-list">
            <li v-for="(item, index) in menu" :key="index">
              <a
                @click="nextChange(item.path)"
                :class="item.path === RouterPath ? 'active' : ''"
                >{{ item.name }}</a
              >
            </li>
          </ul>
        </div>
        <div class="z-btn">
          <a href="http://www.gyycbj.com/jnds/index.html#/Home" target="_blank"
            >透析技能竞赛</a
          >
        </div>
        <div class="ec-btn">
          <span><a :href="urlCH" target="_self">中文</a></span> |
          <span><a :href="urlEN" target="_self">EN</a></span>
        </div>
      </div>
      <!-- 移动导航 -->
      <div class="mobile-menu" v-else>
        <div class="logo"></div>
        <div class="option">
          <div class="ec-btn">
            <span><a :href="urlCH" target="_self">中文</a></span> |
            <span><a :href="urlEN" target="_self">EN</a></span>
          </div>
          <div class="switch" @click="toMobileChange">
            <i class="el-icon-s-fold"></i>
          </div>
        </div>
      </div>
      <!-- 路由占位符 -->
      <transition enter-active-class="animate__animated animate__fadeIn">
        <router-view />
      </transition>
      <!-- 底部 -->
      <div class="footer">
        <div class="footer-menu">
          <div class="footer-logo">
            <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/2D456121F08D4D7386218BFBC8970849-6-2.png" alt="" />
          </div>
          <div class="footer-nav">
            <ul class="footer-nav-top">
              <li>
                <p>创新服务</p>
                <a
                  v-for="(item, index) in footerMenu.Innovate"
                  :key="index"
                  @click="LinkTo(item.name)"
                  >{{ item.text }}</a
                >
              </li>
              <li>
                <p>工业生产</p>
                <a
                  v-for="(item, index) in footerMenu.Industry"
                  :key="index"
                  @click="LinkTo(item.name)"
                  >{{ item.text }}</a
                >
              </li>
              <li>
                <p>商业渠道</p>
                <a
                  v-for="(item, index) in footerMenu.Business"
                  :key="index"
                  @click="LinkTo(item.name)"
                  >{{ item.text }}</a
                >
              </li>
              <li>
                <p>医学培训</p>
                <a
                  v-for="(item, index) in footerMenu.Science"
                  :key="index"
                  @click="LinkTo(item.name)"
                  >{{ item.text }}</a
                >
              </li>
              <li>
                <p>信息平台</p>
                <a
                  v-for="(item, index) in footerMenu.News"
                  :key="index"
                  @click="LinkTo(item.name)"
                  >{{ item.text }}</a
                >
              </li>
              <li>
                <p>公司动态</p>
                <a
                  v-for="(item, index) in footerMenu.Trends"
                  :key="index"
                  @click="LinkTo(item.name)"
                  >{{ item.text }}</a
                >
              </li>
              <li>
                <p>关于我们</p>
                <div class="callmy">
                  <a
                    v-for="(item, index) in footerMenu.About"
                    :key="index"
                    @click="LinkTo(item.name)"
                    >{{ item.text }}</a
                  >
                </div>
              </li>
              <li>
                <p>联系我们</p>
                <a >
                  <img src="./assets/image/home/167.webp" /> 010-67207401</a
                >
                <a 
                  ><img src="./assets/image/home/168.webp" />
                  lijuan@gytcare.com</a
                >
                <a 
                  ><img src="./assets/image/home/166.webp" />
                  北京市朝阳区东四环中路41号嘉泰大厦B座704室
                  <br />
                  一一
                  <br />
                   北京市朝阳区东四环中路41号嘉泰大厦B座713室
                </a>
              </li>
              <li>
                <p>微信公众号</p>
                <div class="ewm"></div>
                <a >【透析专项】</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer-MenuIos">
          <div class="box">
            <div class="top">
              <a @click="LinkTo('home')"
                ><img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/2D456121F08D4D7386218BFBC8970849-6-2.png" alt=""
              /></a>
            </div>
          </div>
          <div class="box">
            <div class="top">创新服务</div>
            <ul class="main">
              <a
                v-for="(item, index) in footerMenu.Innovate"
                :key="index"
                @click="LinkTo(item.name)"
                >{{ item.text }}</a
              >
            </ul>
          </div>
          <div class="box">
            <div class="top">工业生产</div>
            <ul class="main">
              <a
                v-for="(item, index) in footerMenu.Industry"
                :key="index"
                @click="LinkTo(item.name)"
                >{{ item.text }}</a
              >
            </ul>
          </div>
          <div class="box">
            <div class="top">商业渠道</div>
            <ul class="main">
              <a
                v-for="(item, index) in footerMenu.Business"
                :key="index"
                @click="LinkTo(item.name)"
                >{{ item.text }}</a
              >
            </ul>
          </div>
          <div class="box">
            <div class="top">医学培训</div>
            <ul class="main">
              <a
                v-for="(item, index) in footerMenu.Science"
                :key="index"
                @click="LinkTo(item.name)"
                >{{ item.text }}</a
              >
            </ul>
          </div>
          <div class="box">
            <div class="top">信息平台</div>
            <ul class="main">
              <a
                v-for="(item, index) in footerMenu.News"
                :key="index"
                @click="LinkTo(item.name)"
                >{{ item.text }}</a
              >
            </ul>
          </div>
          <div class="box">
            <div class="top">公司动态</div>
            <ul class="main">
              <a
                v-for="(item, index) in footerMenu.Trends"
                :key="index"
                @click="LinkTo(item.name)"
                >{{ item.text }}</a
              >
            </ul>
          </div>
          <div class="box">
            <div class="top">关于我们</div>
            <ul class="main">
              <a
                v-for="(item, index) in footerMenu.About"
                :key="index"
                @click="LinkTo(item.name)"
                >{{ item.text }}</a
              >
            </ul>
          </div>
          <div class="box2">
            <div class="top">联系我们</div>
            <ul class="main">
              <li>
                <span>
                  <img src="./assets/image/home/167.webp" /> 010-67207401</span
                >
                <span
                  ><img src="./assets/image/home/168.webp" />
                  lijuan@gytcare.com</span
                >
                <span
                  ><img src="./assets/image/home/166.webp" />
                  北京市朝阳区东四环中路41号嘉泰大厦B座704室</span
                >
                <span> 北京市朝阳区东四环中路41号嘉泰大厦B座713室</span>
              </li>
            </ul>
          </div>
          <div class="box2">
            <div class="top">微信公众号</div>
            <ul class="main">
              <li>
                <div class="ewm"></div>
                <span>【透析专项】</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer-icp">
          <span>版权所有 国医通(北京)科技发展有限公司</span>
          <span
            ><a
              href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
              target="_blank"
              class="beian"
              >京ICP备17004171号-1</a
            ></span
          >
        </div>
      </div>
      <!-- 回到顶部 -->
      <el-backtop :bottom="100">
        <div class="goUp">
          <img src="./assets/image/home/goup.webp" alt="" />
        </div>
      </el-backtop>
    </div>
    <!-- /主体页面/ -->
  </div>
</template>
<script>


export default {
  data() {
    return {
      urlCH: "", // 中文跳转路径
      urlEN: "", // 英文跳转路径
      mobileMenuIsShow: false, //移动端菜单是否显示
      MenuIsShow: true, //PC菜单是否开启
      screenWidth: document.body.clientWidth, //当前屏幕宽度
      menu: [
        {
          name: "首页",
          path: "home",
          index: 1,
          children: [],
        },
        {
          name: "创新服务",
          path: "Innovate",
          index: 2,
          children: [
            {
              name: "jiceng",
              text: "基层赋能",
              index: "2-1",
            },
            {
              name: "touxi",
              text: "透析中心建设",
              index: "2-2",
            },
            {
              name: "doctorIP",
              text: "医生IP打造",
              index: "2-3",
            },
            {
              name: "kexue",
              text: "科室宣传",
              index: "2-4",
            },
            {
              name: "shuzi",
              text: "数字化营销",
              index: "2-5",
            },
            {
              name: "yidi",
              text: "异地透析",
              index: "2-6",
            },
          ],
        },
        {
          name: "工业生产",
          path: "Industry",
          index: 3,
          children: [
            {
              name: "kaineng",
              text: "康德威",
              index: "3-1",
            },
            {
              name: "water",
              text: "透析水机",
              index: "3-2",
            },
            {
              name: "jizhong",
              text: "集中供液系统",
              index: "3-3",
            },
          ],
        },
        {
          name: "商业渠道",
          path: "Business",
          index: 4,
          children: [],
        },
        {
          name: "医学培训",
          path: "Science",
          index: 5,
          children: [
            {
              name: "zhuanxiang",
              text: "专项培训",
              index: "5-1",
            },
            {
              name: "jiaoxue",
              index: "5-2",
              text: "教学直播",
            },
            {
              name: "xueshu",
              index: "5-3",
              text: "学术推广",
            },
            {
              name: "jineng",
              index: "5-4",
              text: "透析技能竞赛",
            },
            {
              name: "bingli",
              index: "5-5",
              text: "病例征集",
            },
          ],
        },
        {
          name: "信息平台",
          path: "News",
          index: 6,
          children: [
            {
              name: "keshigl",
              text: "科室管理系统",
              index: "6-1",
            },
            {
              name: "watergl",
              text: "水机管理系统",
              index: "6-2",
            },
            {
              name: "huanzhegl",
              text: "患者管理系统",
              index: "6-3",
            },
          ],
        },
        {
          name: "公司动态",
          path: "Trends",
          index: 7,
          children: [],
        },
        {
          name: "关于我们",
          path: "About",
          index: 8,
          children: [
            {
              name: "fazhan",
              text: "发展历程",
              index: "8-1",
            },
            {
              name: "rencai",
              text: "人才招聘",
              index: "8-2",
            },
          ],
        },
      ],
      RouterPath: "home",
      footerMenu: {
        // 创新服务
        Innovate: [
          {
            name: "jiceng",
            text: "基层赋能",
          },
          {
            name: "touxi",
            text: "透析中心建设",
          },
          {
            name: "doctorIP",
            text: "医生IP打造",
          },
          {
            name: "kexue",
            text: "科室宣传",
          },
          {
            name: "shuzi",
            text: "数字化营销",
          },
          {
            name: "yidi",
            text: "异地透析",
          },
        ],
        // 工业生产
        Industry: [
          {
            name: "kaineng",
            text: "康德威",
          },
          {
            name: "kaineng",
            text: "透析水机",
          },
          {
            name: "jizhong",
            text: "集中供液系统",
          },
        ],
        // 商业渠道
        Business: [
          {
            name: "Business",
            text: "商业渠道",
          },
        ],
        // 医学培训
        Science: [
          {
            name: "zhuanxiang",
            text: "专项培训",
          },
          {
            name: "jiaoxue",
            text: "教学直播",
          },
          {
            name: "xueshu",
            text: "学术推广",
          },
          {
            name: "jineng",
            text: "透析技能竞赛",
          },
          {
            name: "bingli",
            text: "病例征集",
          },
        ],
        // 信息平台
        News: [
          {
            name: "keshigl",
            text: "科室管理系统",
          },
          {
            name: "watergl",
            text: "水机管理系统",
          },
          {
            name: "huanzhegl",
            text: "患者管理系统",
          },
        ],
        // 公司动态
        Trends: [
          {
            name: "Trends",
            text: "最新动态",
          },
        ],
        //关于我们
        About: [
          {
            name: "fazhan",
            text: "发展历程",
          },
          {
            name: "rencai",
            text: "人才招聘",
          },
        ],
      },
    };
  },
  created() {
    if (this.screenWidth < 540) {
      this.MenuIsShow = false;
    }
    if (window.location.href.split("/")[2] == "testwww.gytcare.com") {
      this.urlCH = "http://testwww.gytcare.com/#/home";
      this.urlEN = "http://testwww.gytcare.com/en/#/home";
    } else if (window.location.href.split("/")[2] == "www.gytcare.com") {
      this.urlCH = "http://www.gytcare.com/#/home";
      this.urlEN = "http://www.gytcare.com/en/#/home";
    } else {
      this.urlCH = "#";
      this.urlEN = "#";
    }
  },
  mounted() {
    new this.$wow.WOW().init()
    // const that = this;
    // window.onresize = () => {
    //   return (() => {
    //     window.screenWidth = document.body.clientWidth;
    //     that.screenWidth = window.screenWidth;
    //   })();
    // };
  },
  watch: {
    screenWidth() {
      if (this.screenWidth <= 540) {
        this.MenuIsShow = false;
      } else {
        this.MenuIsShow = true;
      }
    },
    $route(to) {
      this.mobileMenuIsShow = false;
      let newpath = to.path.slice(1).split("/")[0];
      // console.log(newpath);
      this.RouterPath = newpath;
    },
  },
  methods: {
    // 二级跳转
    mobileRouterLink(name) {
      this.$router.push({ name });
      this.mobileMenuIsShow = false;
    },
    // 关闭导航栏
    closeMenuChange() {
      this.mobileMenuIsShow = false;
    },
    // 移动端一级导航打开关闭
    handleOpen(key) {
      if (key == 1) {
        this.$router.push({ name: "home" }).catch((err) => err);
        this.mobileMenuIsShow = false;
      } else if (key == 4) {
        this.$router.push({ name: "Business" }).catch((err) => err);
        this.mobileMenuIsShow = false;
      } else if (key == 7) {
        this.$router.push({ name: "Trends" }).catch((err) => err);
        this.mobileMenuIsShow = false;
      }
    },
    handleClose() {},
    //
    toMobileChange() {
      this.mobileMenuIsShow = true;
    },
    nextChange(path) {
      this.$router.push({ name: path });
      // this.RouterPath = path
    },
    LinkTo(name) {
      this.$router.push({ name: name });
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style lang="scss">
#app {
  // width: 100vw;
  .nav {
    height: 1.0638rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .logo {
      width: 1rem;
      height: 0.5957rem;
      background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/2D456121F08D4D7386218BFBC8970849-6-2.png") no-repeat;
      background-size: 100% 100%;
    }
    .active {
      color: #0ca6eb !important;
      padding-bottom: 0.1277rem;
      border-bottom: 0.0319rem solid #0ca6eb;
      border-radius: 0.0106rem;
    }
    .menu {
      .menu-list {
        padding: 0 0.2979rem;
        display: flex;
        li {
          list-style: none;
          padding: 0 0.2979rem;
          a {
            color: #000000;
            cursor: pointer;
            font-size: 0.1915rem;
            font-weight: 700;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-family: Source Han Sans CN;
          }
        }
      }
    }
    .z-btn {
      height: 0.5319rem;
      width: 1.7021rem;
      background: #1ebaff;
      text-align: center;
      line-height: 0.5319rem;
      font-size: 0.1915rem;
      border-radius: 3px;
      cursor: pointer;
      margin-right: 0.383rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-left: 0.6383rem;
      a {
        width: 100%;
        height: 100%;
        display: block;
        color: #fff;
        list-style: none;
      }
    }
    .ec-btn {
      text-align: center;
      font-size: 0.1915rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      span {
        padding: 0 0.1915rem;
        cursor: pointer;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        a {
          color: #000000;
        }
      }
    }
  }
  // 移动端导航内容
  .mobileMenu {
    .menu-content {
      background-color: #fff;
      .el-menu {
        border-right: none;
        .el-submenu__title {
          font-size: 16px;
          border-bottom: 1px solid #eaeaea;
          box-sizing: border-box;
          padding: 0 !important;
          margin: 0 20px;
        }
        .el-submenu__title:hover {
          background-color: #fff;
        }
        .el-menu-item {
          color: #a2a2a2 !important;
        }
      }
    }
  }
  // 移动端导航
  .mobile-menu {
    height: 60px;
    background-color: #fff;
    display: flex;
    align-items: center;
    padding: 0 15px;
    justify-content: space-between;
    .logo {
      height: 40px;
      width: 70px;
      background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/2D456121F08D4D7386218BFBC8970849-6-2.png") no-repeat;
      background-size: 100%;
    }
    .option {
      display: flex;
      align-items: center;
      .ec-btn {
        padding: 0 20px;
        text-align: center;
        font-size: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        span {
          padding: 0 0.1915rem;
          cursor: pointer;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          a {
            color: #000000;
          }
        }
      }
      .switch {
        i {
          color: #898989;
          font-size: 30px;
        }
      }
    }
  }
  // 底部
  .footer {
    .footer-MenuIos {
      display: none;
      padding: 20px 0;
      background-color: #eee;
      @media screen and (max-width: 540px) {
        display: flex;
        flex-wrap: wrap;
      }
      .box {
        flex-basis: 25%;
        box-sizing: border-box;
        flex-shrink: 0;
        .top {
          padding: 0 12px;
          text-align: left;
          height: 50px;
          color: #2b2b2b;
          font-size: 15px;
          overflow: hidden;
          line-height: 50px;
          border-bottom: 1px solid #dbdbdb;
          img {
            width: 57px;
            height: 25px;
            margin-top: 10px;
          }
        }
        .main {
          padding: 0 12px;
          padding-bottom: 27px;
          a {
            color: #9f9f9f;
            overflow: hidden;
            text-align: left;
            display: block;
            padding-top: 14px;
          }
        }
      }
      .box2 {
        flex-basis: 50%;
        box-sizing: border-box;
        flex-shrink: 0;
        .top {
          padding: 0 15px;
          text-align: left;
          height: 50px;
          color: #2b2b2b;
          font-size: 15px;
          line-height: 50px;
          border-bottom: 1px solid #dbdbdb;
          img {
            width: 57px;
            height: 25px;
            margin-top: 10px;
          }
        }
        .main {
          padding: 0 15px;
          padding-bottom: 27px;
          .ewm {
            margin-top: 10px;
            width: 75px;
            height: 75px;
            background: url("./assets/image/home/ewm.webp") no-repeat;
            background-size: 100% 100%;
          }
          a {
            color: #9f9f9f;
            padding-top: 14px;
            display: block;
          }
          span {
            display: block;
            padding-top: 14px;
            color: #9f9f9f;
            overflow: hidden;
            padding-top: 14px;
          }
        }
      }
    }
    .footer-menu {
      // height: 3.6842rem;
      @media screen and (max-width: 540px) {
        display: none;
      }
      padding: 0 1.6842rem;
      margin-bottom: 0.4842rem;
      justify-content: space-between;
      display: flex;
      .footer-logo {
        width: 1.0526rem;
        height: 0.5895rem;
        padding-right: 0.2632rem;
        padding-top: 0.4rem;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .footer-nav {
        width: 100%;
        .footer-nav-top {
          margin: 0;
          // height: 3.6842rem;
          overflow: hidden;
          display: flex;
          position: relative;
          li {
            // float: left;
            padding: 0 0.2947rem;
            font-size: 0.1684rem;
            color: #2b2b2b;
            p {
              padding: 0.4rem 0 0.4421rem 0;
              // border-bottom: 1px solid #dbdbdb;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            a {
              font-size: 0.1474rem;
              color: #9f9f9f;
              cursor: pointer;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: left;
              display: block;
              padding: 0.0842rem 0;
              img {
                margin-right: 0.0526rem;
              }
            }
            .callmy {
              border-right: 1px solid #dbdbdb;
              padding-right: 0.8421rem;
              height: 2.1053rem;
            }
          }

          li:nth-child(8) {
            padding: 0 0 0 0.6316rem;
            // box-sizing: border-box;
            width: 2.2105rem;
            a {
              white-space: initial;
            }
          }
          .ewm {
            width: 1.0526rem;
            height: 1.0526rem;
            background: url("./assets/image/home/ewm.webp") no-repeat;
            background-size: 100% 100%;
          }
        }
        .footer-nav-top::after {
          position: absolute;
          content: "";
          top: 0.8421rem;
          left: 0;
          width: 100%;
          height: 1px;
          background-color: #eeeeee;
        }
      }
    }
    .footer-icp {
      height: 0.6383rem;
      background-color: #d4d4d4;
      line-height: 0.6383rem;
      padding: 0 1.7021rem;
      text-align: left;
      font-size: 0.1489rem;
      color: #666666;
      display: flex;
      justify-content: space-between;
      .beian {
        color: #666;
      }
      .beian:hover {
        color: #333;
        cursor: pointer;
      }
      @media screen and (max-width: 540px) {
        height: 100%;
        display: block;
        font-size: 12px;
        padding: 16px 0 0 15px;
        span {
          display: block;
          padding-bottom: 16px;
        }
      }
    }
  }
  // 回到顶部
  .el-backtop {
    border-radius: 0;
    width: 0.6316rem;
    height: 0.6316rem;
    background-color: #fff0;
    @media screen and (max-width: 540px) {
      height: 1.8947rem;
      width: 1.8947rem;
    }
  }
  .goUp {
    height: 100%;
    width: 100% !important;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0ca6eb;
    // box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
    z-index: 999;
    color: #fff;
    border-radius: 0.0526rem;
    img {
      width: 0.2105rem;
      height: 0.2526rem;
      @media screen and (max-width: 540px) {
        height: 1.0526rem;
        width: 1.0526rem;
      }
    }
  }
}
</style>
